import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Image } from '@chatterbug/aaron'

import { t } from 'src/lib/i18n-react'
import Loader from 'components/Loader'

import { searchIcon, closeIcon } from './assets'

const TextInput = ({ onSearch, isLoading }) => {
  const [inputValue, setInputValue] = useState('')
  const inputRef = useRef(null)
  const setFocus = () => {
    // eslint-disable-next-line no-unused-expressions
    inputRef.current?.focus()
  }

  return (
    <Box>
      <Flex
        justifyContent="center"
        p="2x"
        alignItems="center"
        width="100%"
        borderRadius="0,5x"
        boxShadow="overlay"
        fontSize="sm"
        bg="white100"
      >
        {isLoading ? (
          <Box mr="1x" height={30} width={30}>
            <Loader type="spinner" color="blue" />
          </Box>
        ) : (
          <Box height={30} width={30} mr="1x">
            <Image src={searchIcon} />
          </Box>
        )}
        <Box
          as="input"
          autoFocus
          ref={inputRef}
          placeholder={t('Search for words, grammar, media and more')}
          width="100%"
          border="none"
          fontSize={'sm'}
          fontWeight="normal"
          sx={{
            outline: 'none',
          }}
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value)
          }}
          onKeyDown={onSearch}
        ></Box>
        <Image
          src={closeIcon}
          onClick={() => {
            setInputValue('')
            setFocus()
          }}
          sx={{ cursor: 'pointer' }}
        />
      </Flex>
    </Box>
  )
}

TextInput.propTypes = {
  onSearch: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default TextInput
